<template>
    <div class="table-page flex-lr" v-if="loaded">
        <el-cascader-panel :options="options" :props="selfProps" v-model="selectModel" @change="selectChange"></el-cascader-panel>
        <my-table :name="pageKey" :cols="cols" :data="list" :loading="loading" :page-param="page"
                  :batch="batch" :operate="operate"
                  @init="init" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange" @cndClusterChange="cndClusterChange">
            <template #right>
                <el-button class="btn-blue" plain icon="el-icon-plus" @click="add" :disabled="'M_SM_DI_I'|auth">添加</el-button>
            </template>
        </my-table>

        <common-add ref="add" :dialog="editDialog" :cols="cols" @save="editSave" @delEdit="delEdit"></common-add>
        <common-detail :dialog="detailDialog" :cols="cols" @save="editSave"></common-detail>
    </div>
</template>

<script>
    import myMixin from '@/util/myMixin'
    import tableMixin from '@/util/tableMixin'
    import myService from '@/util/api'


    export default {
        mixins: [tableMixin, myMixin],
        data() {
            return {
                pageKey: 'dict',
                loaded: true,
                api: {
                    list: 'sys/dict/selectDictAndItemPageForWrapper',   // 列表接口
                    detail: 'sys/dictItem/findDictByPk', // 详情接口
                    add: 'sys/dictItem/insertDictItem',      // 新增接口
                    update: 'sys/dictItem/updateDictItem',   // 修改接口
                    del: 'sys/dictItem/deleteDictItem',      // 删除接口

                    leadingOut: 'sys/dict/exportDictAndItem',  // 导出接口
                },

                operate: [
                    {txt: '修改', auth: 'M_SM_DI_E', type: 'primary', icon: 'el-icon-edit', event: this.update, whether: this.updateWhether},
                    {txt: '详情', auth: '', type: 'success', icon: 'el-icon-view', event: this.detail},
                    {txt: '删除', auth: 'M_SM_DI_D', type: 'danger', icon: 'el-icon-circle-close', event: this.del, whether: this.deleteWhether},
                ],

                // 批量操作的参数
                batch: [
                    {txt: '导出', event: this.leadingOut},
                ],
                cols: [
                    {
                        key: "headId",
                        value: "主表ID",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: false,
                        viewAdd: false,
                        viewEdit: false,
                        viewDetail: false,
                        width: 200,
                    },
                    {
                        key: "dataType",
                        value: "数据赋值类型",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: false,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail: false,
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                        type: this.$variable.colType.SELECT,
                        param: {
                           dict: '000006'
                        }
                    },

                    {
                        key: "allowEdit",
                        value: "是否可编辑",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: false,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail: false,
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                        type: this.$variable.colType.SELECT,
                        param: {
                            dict: '000004'
                        }

                    },

                    {
                        key: "dataCode",
                        value: "父键",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: false,
                        viewAdd: false,
                        viewEdit: false,
                        viewDetail: false,
                        minWidth: 200
                    },
                    {
                        key: "dataName",
                        value: "父值",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: false,
                        viewAdd: false,
                        viewEdit: false,
                        viewDetail: false,
                        minWidth: 200,
                    },

                    {
                        key: "id",
                        value: "子表ID",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: false,
                        viewAdd: false,
                        viewEdit: false,
                        viewDetail: false,
                        width: 200,
                    },
                    {
                        key: "itemDataCode",
                        value: "键",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: true,
                        viewDetail: true,
                        minWidth: 200
                    },
                    {
                        key: "itemDataName",
                        value: "值",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: true,
                        viewDetail: true,
                        minWidth: 200,
                    },
                ],

                selectModel: [],
                selfProps: {
                    value: 'id',
                    label: 'dataName',
                },
                options: [],
            }
        },
        created() {

            myService.post('sys/dict/findDictList')
                .then(res => {
                    this.options = res
                    this.selectModel = [res[0].id]
                    this.init()
                })

            // 枚举类型查询
            let dataCode = [];
            for (let i = 0; i < this.cols.length; i++) {
                if (this.cols[i].param && this.cols[i].param.dict) {
                    dataCode.push(this.cols[i].param.dict);
                }
            }
            if (dataCode.length !== 0) {
                this.$api.post('sys/dict/selectDictItemMap', dataCode)
                    .then(res => {
                        for (let i = 0; i < this.cols.length; i++) {
                            if (this.cols[i].param && this.cols[i].param.dict) {
                                let keyValue = {};
                                if(res[this.cols[i].param.dict]){
                                    for (let j = 0; j< res[this.cols[i].param.dict].length; j++){
                                        keyValue[res[this.cols[i].param.dict][j].itemDataCode] = res[this.cols[i].param.dict][j].itemDataName;
                                    }
                                    this.cols[i].param.keyValue = keyValue;
                                }
                            }
                        }
                        this.loaded = false;
                        this.$nextTick(() => {this.loaded = true});
                    });
            }
        },
        methods: {
            updateWhether(item){
                // false表示显示，true表示置灰  0标识不能编辑就是置灰
                return item.allowEdit === 0;
            },
            deleteWhether(item) {
                // false表示显示，true表示置灰  0标识不能编辑就是置灰
                return item.allowEdit === 0;
            },
            queryFunc() {
                return this.selectModel[0] ? {headId: this.selectModel[0]} : {}
            },
            selectChange() {
                this.page.current = 1
                this.init()
            },
            addParam(param) {
                param.headId = this.selectModel[0]
                return param
            },
        }
    }
</script>
